(function () {
  'use strict';

  var LOOKUP_URL = 'https://partner.maluwilz.de/affiliate/partner';
  var COOKIE_NAME = 'mw_aff';
  var COOKIE_TTL_S = 24 * 60 * 60;
  var ATTR_SLUG = 'via-b2b-partner-slug';
  var ATTR_NAME = 'via-b2b-partner-name';
  var LOG_PREFIX = '[mw-aff]';
  var HOUSE = { slug: 'maluwilz', name: '' };

  function lookupPartner(slug) {
    return fetch(LOOKUP_URL + '?slug=' + encodeURIComponent(slug))
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function readCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return null;
    try {
      var data = JSON.parse(decodeURIComponent(match[1]));
      if (!data || !data.slug || !data.expiresAt || Date.now() > data.expiresAt) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeCookie(partner) {
    var data = {
      slug: partner.slug,
      name: partner.name,
      expiresAt: Date.now() + COOKIE_TTL_S * 1000
    };
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(data)) +
      '; path=/; max-age=' + COOKIE_TTL_S + '; SameSite=Lax; Secure';
    return data;
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function setCartAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }

  function syncCartAttributes(cookie) {
    return getCart().then(function (cart) {
      var current = (cart && cart.attributes && cart.attributes[ATTR_SLUG]) || '';
      var wanted = cookie ? cookie.slug : '';
      if (current === wanted) return null;
      var attrs = {};
      attrs[ATTR_SLUG] = wanted;
      attrs[ATTR_NAME] = cookie ? cookie.name : '';
      return setCartAttributes(attrs);
    }).catch(function (e) {
      console.log(LOG_PREFIX, 'cart sync failed', e);
    });
  }

  function watchCartMutations() {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || String(arguments[0]));
      var result = origFetch.apply(this, arguments);
      if (url && /\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(function () { syncCartAttributes(readCookie()); });
      }
      return result;
    };
  }

  function showBanner(name) {
    if (!name) return;
    if (document.getElementById('mw-aff-banner')) return;
    var el = document.createElement('div');
    el.id = 'mw-aff-banner';
    el.textContent = 'Sie kaufen ein über ' + name;
    el.style.cssText = 'position:sticky;top:0;z-index:9999;background:#1a1a1a;color:#fff;' +
      'text-align:center;padding:8px 12px;font-size:14px;';
    document.body.insertBefore(el, document.body.firstChild);
  }

  function ensureCookie(cookie) {
    if (!cookie) cookie = writeCookie(HOUSE);
    showBanner(cookie.slug !== HOUSE.slug ? cookie.name : '');
    syncCartAttributes(cookie);
  }

  function main() {
    watchCartMutations();
    var slug = (new URLSearchParams(location.search).get('via') || '').toLowerCase();
    var cookie = readCookie();

    if (slug && slug !== HOUSE.slug && (!cookie || cookie.slug !== slug)) {
      lookupPartner(slug).then(function (partner) {
        if (!partner) {
          ensureCookie(readCookie());
          return;
        }
        var data = writeCookie(partner);
        showBanner(partner.name);
        syncCartAttributes(data);
      });
      return;
    }

    ensureCookie(cookie);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();